import { createSlice } from '@reduxjs/toolkit';

import { ExternalShareExchangesState } from 'interfaces/external-share-exchange.interface';

import { EXTERNAL_SHARE_EXCHANGE_SLICE_NAME } from './action';
import { createExternalShareExchangeReducer, getExternalShareExchangeReducer } from './reducers';

export const initialState: ExternalShareExchangesState = {
  exchange: {
    data: null,
    isLoading: false,
  },
};

const externalShareExchangeSlice = createSlice({
  name: EXTERNAL_SHARE_EXCHANGE_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    createExternalShareExchangeReducer(builder);
    getExternalShareExchangeReducer(builder);
  },
});

export const externalShareExchangeReducer = externalShareExchangeSlice.reducer;
